export const environment = {
  production: false,
  backendApiConfiguration: {
  api_url: 'https://be.dev-ibs.siemens-healthineers.com/',
  },
  authClientConfiguration: {
    client_id: '55713599-f9fe-4e0d-bf95-ddb3b1f8ade1',
    authorization_url:
      'https://login.microsoftonline.com/5dbf1add-202a-4b8d-815b-bf0fb024e033',
    redirect_url: '/',
    logout_return_to_url: '/',
    redirect_url_login: '/',
  },
};
